import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import entityReducerFactory from './factories/entityReducerFactory';
import mapConstants from '../constants/mapConstants';
import applyReducer, { reduceReducers } from './applyReducer';
import formConstants from '../constants/formConstants';
const entityReducer = entityReducerFactory('map');
const initState = {
  initialIndexQuery: _objectSpread(_objectSpread({}, entityReducer.initState.initialIndexQuery), {}, {
    sortDirection: null
  }),
  selectedMarker: null,
  selectedMapType: null,
  clusterItems: null
};

/**
 *  Set cabinet-specific loading and clear updatedFormType when the index call is made
 */
const index = (state, action) => {
  const currentCabinet = state.currentCabinet;
  const indexQuery = action.indexQuery;
  const _indexQuery$bbox = indexQuery.bbox,
    bbox = _indexQuery$bbox === void 0 ? [0, 0, 0, 0] : _indexQuery$bbox,
    _indexQuery$zoom = indexQuery.zoom,
    zoom = _indexQuery$zoom === void 0 ? 0 : _indexQuery$zoom;
  const mapState = _objectSpread(_objectSpread({}, state), {}, {
    updatedFormType: null,
    [currentCabinet]: _objectSpread(_objectSpread({}, state[currentCabinet]), {}, {
      loading: true,
      bbox,
      zoom
    })
  });
  return mapState;
};
const indexSuccess = state => {
  const currentCabinet = state.currentCabinet,
    initialIndexQuery = state.initialIndexQuery;
  const mapState = _objectSpread({}, state);
  const currentMapState = _objectSpread({}, state[currentCabinet]);
  const entityResponseProps = Object.keys(entityReducer.initState);
  entityResponseProps.forEach(prop => {
    // only add entity state to the cabinet-specific property
    currentMapState[prop] = state[prop];

    // remove cabinet-specific entity state from top level
    delete mapState[prop];
  });

  // set the cabinet-specific state to the top-level
  mapState[currentCabinet] = currentMapState;
  mapState.initialIndexQuery = initialIndexQuery;
  return mapState;
};
const clusterItemsSuccess = (state, action) => {
  const data = action.payload || [{
    type: 'FeatureCollection',
    features: []
  }];
  return _objectSpread(_objectSpread({}, state), {}, {
    clusterItems: data[0],
    loading: false
  });
};
const saveSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  updatedFormType: action.data.formType.identifier
});
const setCurrent = (state, _ref) => {
  var _state$currentCabinet, _state$currentCabinet2;
  let currentCabinet = _ref.currentCabinet;
  return _objectSpread(_objectSpread({}, state), {}, {
    currentCabinet,
    [currentCabinet]: _objectSpread(_objectSpread({}, state[currentCabinet]), {}, {
      bbox: ((_state$currentCabinet = state[currentCabinet]) === null || _state$currentCabinet === void 0 ? void 0 : _state$currentCabinet.bbox) || [0, 0, 0, 0],
      zoom: ((_state$currentCabinet2 = state[currentCabinet]) === null || _state$currentCabinet2 === void 0 ? void 0 : _state$currentCabinet2.zoom) || 0
    })
  });
};
const setInitialized = (state, action) => {
  const cabinetIdentifier = action.cabinetIdentifier;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      initialized: true
    })
  });
};
const setType = (state, action) => {
  const selectedMapType = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedMapType
  });
};
const setView = (state, action) => {
  const _action$payload = action.payload,
    cabinetIdentifier = _action$payload.cabinetIdentifier,
    bbox = _action$payload.bbox,
    zoom = _action$payload.zoom;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      bbox,
      zoom
    })
  });
};
const reducers = {
  [mapConstants.CLUSTER_ITEMS_SUCCESS]: clusterItemsSuccess,
  [mapConstants.CLUSTER_ITEMS_FAILURE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    loading: false,
    error: action.error
  }),
  [mapConstants.INDEX]: reduceReducers(entityReducer.reducers[mapConstants.INDEX], index),
  [mapConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[mapConstants.INDEX_SUCCESS], indexSuccess),
  [mapConstants.SET_CURRENT]: setCurrent,
  [mapConstants.SET_INITIALIZED]: setInitialized,
  [mapConstants.SET_TYPE]: setType,
  [mapConstants.SET_VIEW]: setView,
  [formConstants.SAVE_SUCCESS]: saveSuccess
};
export default applyReducer(reducers, initState);